import { makeAutoObservable } from "mobx";
import type { apiTypes } from "../../services/APIService";
import { AttributeShelf, InputShelf, LoaderShelf } from "../../shelves";

export class Store {
	public preSimulation = new AttributeShelf<apiTypes.PreSimulation | null>(null);
	public loader = new LoaderShelf();
	public nameInput = new InputShelf("");
	public emailInput = new InputShelf("");
	public phoneInput = new InputShelf("");
	public isAgreedWithTermsChecked = new AttributeShelf(false);

	constructor() {
		makeAutoObservable(this);
	}
}
